import React from "react";
import {ProjectHeadingState, ProjectHeadingContext} from "./project-heading-context-props.ts";

export const useProjectHeadingContext = () => {
    const context = React.useContext(ProjectHeadingContext);
    if (context === undefined) {
        throw new Error('useProjectHeadingContext must be used within a ProjectHeadingProvider');
    }
    return context;
};

export const useProjectFormHeadingLayoutEffect = (next: ProjectHeadingState): void => {
    const { setHeading, clearHeading } = useProjectHeadingContext();

    React.useLayoutEffect(() => {
        setHeading(next);
        return () => {
            clearHeading();
        };
    }, [setHeading, clearHeading, next]);
};